/**
 * Created by coolguy on 2018/9/7.
 * 参考：
 * https://serverless-stack.com/chapters/code-splitting-in-create-react-app.html
 */
import React, { Component } from 'react';

export default function asyncComponent(importComponent) {
  class AsyncComponent extends Component {
    constructor(props) {
      super(props);

      this.state = {
        component: null
      };
    }

    // 考虑到某些异常环境需要在微信Pc浏览中进行，这个浏览器目前看到的chrome版本是53，
    // 53还不支持async
    componentDidMount() {
      importComponent().then(dt => {
        const { default: component } = dt;
        this.setState({
          component: component
        });
      });
    }

    render() {
      const C = this.state.component;

      return C ? <C {...this.props} /> : null;
    }
  }

  return AsyncComponent;
}
